module.exports = __webpack_public_path__ + "static/bubleBackground-2923b6e1a1e7a70a1a97932fa14fa038.png";